import { Popper } from '@mui/material'
import UserChatBubbleFloatingPopperBody from './UserChatBubbleFloatingPopperBody'

export default function UserChatBubbleFloatingPopper({
  showFloatingToolbar,
  bubbleAnchorRef,
  toolbarPlacement,
  ...bodyProps
}) {
  return (
    <Popper
      open={showFloatingToolbar}
      anchorEl={() => bubbleAnchorRef.current}
      placement={toolbarPlacement}
      modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      popperOptions={{ strategy: 'fixed' }}
      sx={{ zIndex: (theme) => theme.zIndex.modal }}
    >
      <UserChatBubbleFloatingPopperBody {...bodyProps} />
    </Popper>
  )
}
